import { Icon, Spinner } from '@chakra-ui/react';
import { CustomSelectStateProps } from '@monetize/types/app';
import React, { FC } from 'react';
import { FiChevronDown } from 'react-icons/fi';
import { MdClose } from 'react-icons/md';
import { MCustomIconButton, MFlex, MText } from '../..';
import { truncateMiddle } from '../../../../utils';
import { MTertiaryArrowButton } from '../../MTertiaryArrowButton';
export interface QuoteSelectInputProps extends Pick<
  CustomSelectStateProps,
  | 'getTitleFromValue'
  | 'disabled'
  | 'isReadOnly'
  | 'onOpen'
  | 'onClose'
  | 'loading'
  | 'loadingRenderer'
  | 'value'
  | 'onToggleOpen'
  | 'externalLoading'
  | 'placeholder'
  | 'isOpen'
  | 'items'
  | 'cursor'
  | 'setCursor'
  | 'handleChange'
  | 'showContentInInput'
  | 'renderContentInInput'
  | 'inputProps'
  | 'renderRightElement'
  | 'clearable'
  | 'onClear'
  | 'onChange'
  | 'queryResultCount'
  | 'query'
  | 'onQueryKeyDown'
  | 'onQueryChange'
  | 'displayAvatar'
  | 'renderInputLeftElement'
  | 'inputLeftElementContent'
  | 'isSubtitleItem'
  | 'isTruncatedInputTitle'
> {
  ref: any;
}
export const QuoteSelectInput: FC<QuoteSelectInputProps> = React.forwardRef<
  any,
  QuoteSelectInputProps
>(
  (
    {
      getTitleFromValue,
      disabled,
      isReadOnly,
      onOpen,
      onClose,
      loading,
      loadingRenderer,
      value,
      onToggleOpen,
      externalLoading,
      placeholder,
      isOpen,
      showContentInInput,
      renderContentInInput,
      inputProps,
      renderRightElement,
      clearable,
      onClear,
      onChange,
      inputLeftElementContent,
      isTruncatedInputTitle,
    },
    ref,
  ) => {
    const rightElement = renderRightElement && renderRightElement({ value });

    const handleOnClear = (e: React.MouseEvent<HTMLElement>) => {
      e.stopPropagation();
      if (onClear) {
        onClear();
      } else {
        onChange && onChange('' as any);
      }
    };

    let rightMargin = rightElement ? rightElement.width : 6;
    if (clearable && value && !disabled) {
      rightMargin += 4;
    }

    const title = getTitleFromValue(value) || '';
    const inputTitle = isTruncatedInputTitle ? truncateMiddle(title) : title;

    if (disabled || isReadOnly) {
      return (
        <>
          {showContentInInput &&
            renderContentInInput &&
            renderContentInInput({ onToggleOpen, inputTitle })}
          {showContentInInput && !renderContentInInput && (
            <MFlex align="center" onClick={onToggleOpen}>
              <MText
                fontWeight="normal"
                truncate
                lineClamp={2}
                whiteSpace="initial"
              >
                {inputTitle}
              </MText>
            </MFlex>
          )}
        </>
      );
    }

    const onBlur = (ev: any) => {
      // Don't close popover if focus is within the popover content. zag
      // focuses the first tabbable element on open (the search box when there
      // is one), so match descendants, not just the content element.
      if (ev.relatedTarget?.closest?.('.chakra-popover__content')) {
        return;
      }
      onClose();
    };

    return (
      <MTertiaryArrowButton
        ref={ref}
        isOpen={isOpen}
        onClick={onToggleOpen}
        showArrow={false}
        onBlur={onBlur}
      >
        <MFlex alignItems="center" mr="2">
          {showContentInInput &&
            renderContentInInput &&
            renderContentInInput({ onToggleOpen, inputTitle, isOpen })}
          {showContentInInput && !renderContentInInput && (
            <MText
              fontWeight="normal"
              truncate
              color="inherit"
              whiteSpace="initial"
              textAlign="left"
              wordBreak="break-all"
              lineClamp={2}
            >
              {inputTitle}
            </MText>
          )}
          {!inputTitle && <MText color="inherit">{placeholder}</MText>}
        </MFlex>

        {!isReadOnly && (
          <MFlex px="0" mx="0">
            {rightElement?.content}
            {clearable && value && !disabled && (
              <MCustomIconButton
                icon={MdClose}
                aria-label="Clear"
                bg="none"
                color="tPurple.dark"
                _hover={{
                  bg: 'none',
                }}
                ml="2"
                btnSize={4}
                padding={0}
                containerSize={4}
                onClick={handleOnClear}
              />
            )}
            {loading || externalLoading ? (
              <>
                {loadingRenderer ? (
                  loadingRenderer
                ) : (
                  <Spinner size="xs" mx="1" />
                )}
              </>
            ) : (
              <Icon
                fontSize="20"
                zIndex="1"
                color="inherit"
                opacity={disabled ? 0.25 : 'unset'}
                asChild
              >
                <FiChevronDown onClick={!disabled ? onToggleOpen : () => {}} />
              </Icon>
            )}
          </MFlex>
        )}
      </MTertiaryArrowButton>
    );
  },
);
